import { render } from "./MBPDropDown.vue?vue&type=template&id=1f352672&scoped=true"
import script from "./MBPDropDown.vue?vue&type=script&lang=js"
export * from "./MBPDropDown.vue?vue&type=script&lang=js"

import "./MBPDropDown.vue?vue&type=style&index=0&id=1f352672&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f352672"]])

export default __exports__